import React, { useRef, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const ReCaptcha = ({ onVerify, siteKey, theme = 'light', size = 'normal' }) => {
  const recaptchaRef = useRef(null);

  const handleChange = (token) => {
    if (token) {
      onVerify(token);
    }
  };

  const resetRecaptcha = () => {
    if (recaptchaRef.current) {
      recaptchaRef.current.reset();
    }
  };

  // Expose reset function to parent component
  useEffect(() => {
    if (window.resetRecaptcha) {
      window.resetRecaptcha = resetRecaptcha;
    } else {
      window.resetRecaptcha = resetRecaptcha;
    }
  }, []);

  // Check if siteKey is provided
  if (!siteKey) {
    console.error('ReCAPTCHA siteKey is missing. Please set REACT_APP_RECAPTCHA_SITE_KEY in your .env file');
    return (
      <div className="recaptcha-container" style={{ marginBottom: '1rem' }}>
        <div style={{ 
          padding: '10px', 
          border: '1px solid #ccc', 
          borderRadius: '4px', 
          backgroundColor: '#f9f9f9',
          color: '#666',
          textAlign: 'center'
        }}>
          {process.env.NODE_ENV === 'development' ? (
            '🛠️ Development Mode: reCAPTCHA disabled'
          ) : (
            '⚠️ ReCAPTCHA not configured. Please set REACT_APP_RECAPTCHA_SITE_KEY in your .env file'
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="recaptcha-container" style={{ marginBottom: '1rem' }}>
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={siteKey}
        onChange={handleChange}
        theme={theme}
        size={size}
      />
    </div>
  );
};

export default ReCaptcha; 